var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateWheelNav(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9330_22066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7754 18.956L46.0907 16.5586L40.6205 18.6609L39.8762 21.7324L37.0156 34.7094L46.3046 38.7561L47.4574 37.2678C49.0478 34.0059 49.9397 30.3406 49.9397 26.4663C49.9397 23.8479 49.5301 21.325 48.7754 18.956Z",
    fill: "#F32A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2117 33.1367L35.9516 34.7114L27.5703 40.6149L31.3058 48.9489L33.9726 49.6098V49.6108C39.9321 47.3946 44.7276 42.8717 47.4906 37.2012L39.2117 33.1367Z",
    fill: "#E25297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7808 40.8526L29.0025 39.6061L18.3754 37.9922L13.2695 46.195L15.6197 49.1551V49.1562C18.6094 50.442 21.9036 51.1541 25.3641 51.1541C28.3921 51.1541 31.2924 50.6094 33.9733 49.6104V49.6094L30.7808 40.8526Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8695 37.7829L12.9626 28.5039L2.65625 31.6926V36.1577C5.14379 41.982 9.80701 46.6556 15.6241 49.1567V49.1557L19.359 40.6151L18.8695 37.7829Z",
    fill: "#77CCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04374 14.7012L2.24518 17.8024H2.24414C1.2327 20.4989 0.679688 23.4189 0.679688 26.4677C0.679688 29.9075 1.38343 33.1819 2.65371 36.157H2.65475L11.2525 32.5561L12.3766 29.974L13.0516 17.2727L5.04374 14.7012Z",
    fill: "#29C18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5919 4.23828H14.6193C8.94155 6.98881 4.47687 11.8495 2.24609 17.8028H2.24713L10.953 21.1313L16.6453 18.2496L24.1732 11.4779L19.5919 4.23828Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9867 21.7347L39.5307 19.707L33.911 21.1318L33.6083 23.7253C33.8963 24.5871 34.0511 25.5102 34.0511 26.4686C34.0511 27.795 33.7538 29.0507 33.2227 30.1744L33.3443 32.2438L37.0161 34.1977L39.2122 33.137C40.1852 31.1204 40.7309 28.8584 40.7309 26.4686C40.731 24.8168 40.469 23.2264 39.9867 21.7347Z",
    fill: "#F79781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2238 30.1738C32.2747 32.1832 30.5782 33.7695 28.493 34.5741L27.6914 36.0819L29.3622 40.3605L30.782 40.8527C34.4857 39.4577 37.5076 36.6749 39.2134 33.1364L33.2238 30.1738Z",
    fill: "#E9ADCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4932 34.5743C27.5233 34.9496 26.4682 35.1554 25.3653 35.1554C24.1844 35.1554 23.0597 34.9205 22.0337 34.4922L20.2806 34.6822L18.1953 38.9334L19.3559 40.6149C21.2021 41.4007 23.2333 41.8353 25.3653 41.8353C27.2718 41.8353 29.0971 41.4881 30.7822 40.8529L28.4932 34.5743Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4132 29.9742L16.0416 28.9824L11.5654 30.5336L11.25 32.5563C12.8124 36.1749 15.7251 39.072 19.354 40.6146L22.0317 34.4919C19.9725 33.6374 18.3124 32.0106 17.4132 29.9742Z",
    fill: "#BBE6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2004 4.79893C33.6869 2.87585 29.6536 1.78125 25.3657 1.78125C21.5122 1.78125 17.8656 2.66379 14.6172 4.2376L18.6203 12.6576L22.5974 14.4412L35.1109 16.5597L38.752 8.83305L37.2004 4.79893Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6439 17.0504C52.7676 17.407 52.5701 17.7947 52.2104 17.907L48.8424 18.9579L42.463 20.9486C41.0368 16.5161 37.9411 12.8331 33.9141 10.6419L37.1552 4.79985L38.8704 1.70836C39.0513 1.38092 39.4671 1.26554 39.7904 1.45369C45.753 4.91004 50.3653 10.4371 52.6439 17.0504Z",
    fill: "#F79A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6799 26.4668C16.6799 25.4304 16.8607 24.4367 17.1944 23.5156L17.1177 19.8945H13.3926L10.9522 21.13C10.3368 22.7922 10 24.5905 10 26.4668C10 28.63 10.447 30.6882 11.2536 32.5552L17.4169 29.9731C16.9429 28.9013 16.6799 27.7153 16.6799 26.4668Z",
    fill: "#94DAC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7371 13.6639L18.6187 12.6562C15.0916 14.3797 12.3234 17.4161 10.9492 21.1293L17.1914 23.5149C17.9524 21.4089 19.5033 19.6812 21.4877 18.6906V18.6895L22.9177 17.0794L21.7371 13.6639Z",
    fill: "#C4DD81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6804 12.9498L32.6791 12.9496C30.5045 11.7709 28.014 11.1016 25.3664 11.1016C22.9465 11.1016 20.6575 11.6608 18.6211 12.6587L21.4901 18.6931C22.6565 18.1109 23.9735 17.7814 25.3664 17.7814C26.8384 17.7814 28.224 18.1473 29.4382 18.7939L31.6245 18.9015L33.7637 16.0493L32.6804 12.9498Z",
    fill: "#FFEDAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4625 20.9473L39.9427 21.7332L33.6109 23.7238C32.903 21.5939 31.3566 19.8119 29.4023 18.7734L32.634 12.9483L33.9136 10.6406C37.9406 12.8319 41.0363 16.5149 42.4625 20.9473Z",
    fill: "#F8CD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6197 30.072C25.3335 30.072 25.1016 29.8401 25.1016 29.5539V22.9635C25.1016 22.6772 25.3335 22.4453 25.6197 22.4453C25.906 22.4453 26.1379 22.6772 26.1379 22.9635V29.5539C26.1379 29.8401 25.906 30.072 25.6197 30.072Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9132 26.7766H22.3229C22.0366 26.7766 21.8047 26.5447 21.8047 26.2584C21.8047 25.9722 22.0366 25.7402 22.3229 25.7402H28.9132C29.1995 25.7402 29.4314 25.9722 29.4314 26.2584C29.4314 26.5447 29.1995 26.7766 28.9132 26.7766Z",
    fill: "#123051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9330_22066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.679688 0.257812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateWheelNav);
export default __webpack_public_path__ + "static/media/createWheelNav.b7e2fe0147d6022bacc9c86c32f350e6.svg";
export { ForwardRef as ReactComponent };